/**
 * Fake Journey Id used when previewing a Journey that doesn't have one (i.e. a template).
 * @deprecated since templates should be removed
 */
export const PREVIEW_JOURNEY_ID = 'fake-preview-id'

/**
 * A constant string used to represent a missing value in various contexts.
 *
 * Currently used to satisfy the requirements despite the missing data while
 * performing schema transformations.
 */
export const MISSING_STRING = 'missing'
